<template>
	<el-row>
		<div style="padding:20px 20px;border:1px solid #ebeef5;margin-top:20px;">
			<i class="el-icon-tickets" style="font-size:18px;margin-right:5px" />
			<span> {{ oneInfo.namePath }} </span>
		</div>
		<el-col :span="24">
			<div class="flex">
				<el-card shadow="hover" v-for="(item, index) in list" :key="index">
					<el-image style="width: 100px;height:100px;" :src="item.imgUrl +'?x-oss-process=image/resize,w_50'"
						:preview-src-list="item.imgUrl.split(',')" fit="fill" v-if="item.urlType == 1" />
					<video :src="item.imgUrl" style="width: 100px;height:100px;" controls="controls"
						v-if="item.urlType == 2"></video>
					<div class="name">本月下载:{{ item.thisMonth }}</div>
					<div class="name">上月下载:{{ item.lastMonth }}</div>
					<div class="btnBox">
						<!-- <el-button type="primary" icon="el-icon-edit" circle size="mini" @click.stop="open(item)">
                        </el-button> -->
						<el-button type="danger" icon="el-icon-delete" circle size="mini" @click.stop="remove(item)">
						</el-button>
					</div>
				</el-card>
				<el-card shadow="hover">
					<div class="addBox" @click="open()">+</div>
				</el-card>
			</div>
		</el-col>
		<el-dialog :title="title" :visible.sync="dialogVisible" width="50%">
			<el-form :model="form" ref="form" :rules="rules" label-width="80px" label-position="right">
				<el-form-item label="上传类型" prop="type">
					<el-radio-group v-model="form.type" @input="changeRadio">
						<el-radio :label="1">本地上传</el-radio>
						<el-radio :label="2">图片库选择</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="上传类型" v-if="form.type == 1">
					<el-radio-group v-model="urlType" @input="changeRadio2">
						<el-radio :label="1">图片</el-radio>
						<el-radio :label="2">视频</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="上传图片" v-if="form.type == 1 && urlType == 1">
					<el-upload multiple :class="{ hide: hideUpload }" :action="action" list-type="picture-card"
						:limit="9" :on-success="getPictrueURL" accept=".jpg,.png" :file-list="fileList"
						:on-remove="handleRemove">
						<i class="el-icon-plus" />
					</el-upload>
				</el-form-item>
				<el-form-item label="上传视频" v-if="form.type == 1 && urlType == 2">
					<p v-if="fileListUp.length == 0">
						<el-upload multiple :class="{ hide: hideUpload }" :action="action" list-type="picture-card"
							:limit="1" :on-success="getPictrueURL" accept=".mp4" :file-list="fileList"
							:on-remove="handleRemove">
							<i class="el-icon-plus" />
						</el-upload>
					</p>
					<p v-if="fileListUp.length > 0" style="display: flex;align-items: center;">
						<video :src="fileListUp[0].imgUrl" style="width: 250px;height: 200px;"
							controls="controls"></video>
						<el-button @click="delUrl" icon="el-icon-delete" type="primary" size="mini"
							style="margin-left: 10px;">
						</el-button>
					</p>
				</el-form-item>
				<el-form-item label="选择类目" v-if="form.type == 2">
					<el-cascader ref="cascader" @change="kwChange($event)" v-model="ClassificationName"
						:options="Classification" :props="classProps">
					</el-cascader>
				</el-form-item>
				<el-form-item v-if="form.type == 2">
					<div style="display: flex;flex-wrap:wrap;width: 100%;">
						<div style="margin-right: 10px;position: relative;" v-for="item in list2" :key="item.imgId">
							<el-image style="width: 100px;height: 100px;"
								:src="item.imgUrl +'?x-oss-process=image/resize,w_50'" v-if="item.urlType == 1">
							</el-image>
							<video style="width: 100px;height: 100px;" :src="item.imgUrl" v-if="item.urlType == 2">
							</video>
							<el-checkbox @change="changImg(item)" v-model="item.isShow"
								style="position: absolute;right: 0;top: -15px;" />
						</div>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button @click="cancel">取 消</el-button>
					<el-button type="primary" @click="submit">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	import httpClient from '../../util/request.js';
	export default {
		data() {
			return {
				urlType: 1,
				Classification: [],
				ClassificationName: '',
				classProps: {
					label: 'name',
					value: 'id',
					children: 'children',
				},
				action: httpClient.prefix + '/api/material/storage/create',
				hideUpload: false,
				oneInfo: {},
				fileList: undefined,
				fileListUp: [],
				title: "",
				type: null,
				dialogVisible: false,
				form: {
					id: "",
					name: "",
					type: 1
				},
				rules: {
					name: [{
						required: true,
						message: "请输入一级文件夹名",
						trigger: "change"
					}, ],
				},
				list: [],
				list2: [],
			};
		},
		created() {
			console.log(this.$route.query);
			this.oneInfo = this.$route.query
			this.loadData()
			this.getClassification()
		},
		methods: {
			cancel(){
				this.dialogVisible = false,
				this.hideUpload = false
			},
			delUrl() {
				this.fileListUp = []
				this.fileList = []
				this.hideUpload = false
			},
			changImg(item) {
				console.log(item.isShow);
				var list = []
				if (this.list2.length > 0) {
					this.list2.forEach(item => {
						if (item.isShow) {
							list.push({
								imgId: item.imgId,
								imgUrl: item.imgUrl
							})
						}
					})
				}
				this.fileListUp = list
				console.log(this.fileListUp);
			},
			kwChange(value, index) {
				var id = value[2]
				// var label = this.$refs.cascader.getCheckedNodes()[0].pathLabels;
				console.log(id);
				this.loadData2(id)
			},
			loadData2(id) {
				this.list2 = []
				this.$http.get(`/api/material/categories/material/all?categoryId=` + id, {}).then(res => {
					console.info("loadData", res.data)
					if (res.data.length > 0) {
						res.data.forEach(item => {
							if (item.imgUrl.substring(item.imgUrl.length - 4) == ".mp4") {
								item.urlType = 2
							} else {
								item.urlType = 1
							}
							this.list2.push({
								imgId: item.imgId,
								imgUrl: item.imgUrl,
								isShow: false,
								urlType: item.urlType
							})
						})
					}
				})
			},
			loadData() {
				this.$http.get(`/api/material/categories/material/all?categoryId=` + this.oneInfo.id, {}).then(res => {
					if (res.data.length > 0) {
						res.data.forEach(item => {
							console.log(item.imgUrl);
							if (item.imgUrl.substring(item.imgUrl.length - 4) == ".mp4") {
								item.urlType = 2
							} else {
								item.urlType = 1
							}
						})
					}
					this.list = res.data
					console.info("loadData", res.data)
				})
			},
			changeRadio(val) {
				console.log(val);

			},
			changeRadio2(val) {
				console.log(val);
				this.fileList = []
				this.fileListUp = []
				this.hideUpload = false
			},
			getPictrueURL(res, file, fileList) {
				console.info("getPictrueURL", res, file, fileList)
				this.fileListUp.push({
					imgId: res.id,
					imgUrl: res.url
				})
				if (this.urlType == 1) {
					this.hideUpload = fileList.length >= 9;
				} else {
					this.hideUpload = fileList.length >= 1;
				}
				console.log(this.fileListUp);
			},
			handleRemove(file, fileList) {
				// let files = this.fileList.split(",");
				// files.splice(files.indexOf(file.url), 1);
				// this.fileList = files.length === 0 ? "" : files.join(",");
				this.fileListUp.splice(this.fileListUp.findIndex(e => e.imgUrl === file.url), 1)
				this.hideUpload = fileList.length >= 1;
			},
			remove(row) {
				this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.$http.delete(
						'/api/material/categories/material/' + this.oneInfo.id + "?imgUrl=" + row.imgUrl, {}
					).then(res => {
						console.info("sumbit", res)
						if (res.status == 500) {
							console.info("系统异常")
						}
						if (res.status == 202) {
							console.info("存在子节点,不允许被删除")
						}
						this.loadData();
					})
				}).catch(() => {
					this.$message.info('已取消删除')
				})
			},
			open(row) {
				this.dialogVisible = true;
				this.title = "素材添加"
				this.fileList = []
				this.fileListUp = []
				this.ClassificationName = ''
				this.type = null
				this.list2 = []
			},
			submit() {
				if (this.fileListUp.length > 0) {
					this.$http.post('/api/material/categories/material/' + this.oneInfo.id, this.fileListUp).then(res => {
						// this.hideUpload = true
						this.dialogVisible = false
						this.loadData()
						this.hideUpload = false
					})
				} else {
					this.$message.error('请先选择照片')
				}
			},
			getClassification() {
				this.$http.get('/api/material/categories/0', {}).then(res => {
					console.info("Classification", res.data.children)
					let data = res.data.children
					if (data.length > 0) {
						data.forEach(item => {
							item.children.forEach(item2 => {
								item2.children.forEach(item3 => {
									item3.children = null
								})
							})
						})
					}
					this.Classification = res.data.children
				})
			},
		},
	};
</script>

<style scoped>
	::v-deep .el-card__body {
		padding: 0;
	}

	::v-deep .el-card {
		width: 100px;
		height: 190px;
		margin: 10px;
	}

	.btnBox {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.flex {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}

	.addBox {
		font-size: 24px;
		height: 190px;
		line-height: 190px;
		text-align: center;
	}

	.name {
		width: 100%;
		padding: 5px 0;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
	}

	::v-deep.hide .el-upload--picture-card {
		display: none;
	}
</style>
